/*
 * Copyright (C) 2019 Frontier Developments PLC.
 *
 * API client exception class.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// generate prototype of Error
import BaseError from './BaseError';

/**
 * API exception type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class ApiException extends BaseError {
    constructor(public status: number, public response: any, public params: any = {}, public additional: any = {}) {
        super();
    }
}
